
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image file={require('images/icon_st_01.png')} className='tier right' mdxType="Image" /> <b>Potwale</b> nehmen beim Schlafen eine senkrechte Position im Wasser ein. Sie schlafen etwa zwei Stunden.<br /><br />
    <Image file={require('images/icon_st_02.png')} className='tier left' mdxType="Image" /> <b>Sepien</b> erleben so wie Menschen eine REM-Schlafphase. Sie wechseln dabei die Farbe und zucken mit den Armen. Sie schalfen etwa 8 Stunden.<br /><br />
    <Image file={require('images/icon_st_03.png')} className='tier right' mdxType="Image" /> <b>Seeotter</b> wickeln sich zum Schlafen in Algen ein oder halten einander an den Pfoten um nicht abzutreiben.<br /><br />
    <Image file={require('images/icon_st_04.png')} className='tier right' mdxType="Image" /> <b>Walrösser</b> bleiben 84 Stunden wach und schlafen dann für 19 Stunden.<br /><br />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;